import { io, Socket } from "socket.io-client";
import { useApi } from "../hooks/useApi";
import { getToken } from "../hooks/storage/tokenStorage";

const api = useApi();

export async function initSocket(): Promise<Socket | null> {
  //get urlApi
  const urlApi = import.meta.env.DEV ? import.meta.env.VITE_API_SOCKET_CHAT_URL_DEV : import.meta.env.VITE_API_SOCKET_CHAT_URL_PROD

  //pick-up token into locastorage
  const token = await getToken();

  return new Promise((resolve, reject) => {

    if (!token) {
      return reject(new Error("Token manquant"));
    }

    let isResolved = false;
    let isServerConfirmed = false;

    //init connexion to api
    const socket = io(`${urlApi}/chat`,
      {
        auth: {
          token: token
        },
        transports: ["websocket", "polling"],
        reconnection: false
      }
    );

    // 1. Confirmation côté serveur
    socket.on("connection-confirmed", () => {
      isServerConfirmed = true;
    });

    // 2. Connexion socket
    socket.on("connect", () => {
      // console.log("✅ Événement connect reçu :", socket.id);
      // console.log("socket connecté: ", socket.connected);

      // Attente active de la vraie disponibilité de la socket
      const interval = setInterval(() => {
        if (socket.connected && isServerConfirmed && !isResolved) {
          clearInterval(interval);
          isResolved = true;
          // console.log("✅ Socket connectée ET confirmée par l'api, résolution");
          resolve(socket);
        }
      }, 50);

      // Sécurité : timeout max 500ms
      setTimeout(() => {
        if (!isResolved) {
          clearInterval(interval);
          reject(new Error("⛔ Socket non prête ou confirmation manquante après délai"));
        }
      }, 500);
    });

    // Gère les erreurs de connexion
    socket.on("error", (error) => {
      reject(error);
    });
  })
}

export async function travSendMessage({ content, res_troc_id, trav_troc_id, socket }: { content: string, res_troc_id: number, trav_troc_id: number, socket: Socket }) {
  return new Promise((resolve, reject) => {
    if (!socket || !socket.connected) {
      console.error("[Socket] Socket non connectée (voyageur)");
      return reject("Socket non connectée");
    }

    let isHandled = false;

    const handleAck = (data: any) => {
      if (isHandled) return;
      isHandled = true;

      socket.off("receptionAccused", handleAck);
      socket.off("error", handleError);
      resolve(data);
    };

    const handleError = (error: any) => {
      if (isHandled) return;
      isHandled = true;

      socket.off("receptionAccused", handleAck);
      socket.off("error", handleError);
      reject(error);
    };

    // 🔁 Nettoyage préalable pour éviter les doublons
    socket.off("receptionAccused", handleAck);
    socket.off("error", handleError);

    socket.once("receptionAccused", handleAck);
    socket.once("error", handleError);

    //emit message after to have initSocket()
    socket.emit('send-message-of-t', { content, res_troc_id, trav_troc_id });
  })
}

export async function resSendMessage({ content, res_troc_id, trav_troc_id, socket }: { content: string, res_troc_id: number, trav_troc_id: number, socket: Socket }) {
  return new Promise((resolve, reject) => {

    //checker si socket est bien défini avant d’émettre
    if (!socket || !socket.connected) {
      // console.log("socket pas connecté!");
      return reject("Socket non connectée");
    }

    socket.removeAllListeners("receptionAccused");
    socket.removeAllListeners("error");

    // console.log("socket connecté!");

    const handleAck = (data: any) => {
      // console.log("accusé reçu:", data);
      resolve(data);
    };

    const handleError = (error: any) => {
      reject(error);
    };

    socket.once("receptionAccused", handleAck);
    socket.once("error", handleError);

    socket.emit('send-message-of-r', { content, res_troc_id, trav_troc_id });
  });
}

export async function getMessagesForT(res_troc_id: number): Promise<{
  discussions: {
    sender: string;
    content: string;
    type: "received" | "sent";
  }[]
} | number> {
  try {
    const response = await api.get(`discussion/list/resTrocId/${res_troc_id}`);
    if (response.status === 200) {
      return response.data;
    }
    else if (response.data === 204) {
      return response.data;
    }
    else {
      throw new Error(`Statut de réponse inconnu : ${response.status}`);
    }

  }
  catch (error) {
    throw error;
  }
}

export async function getMessagesForR(trav_troc_id: number): Promise<{
  discussions: {
    sender: string;
    content: string;
    type: "received" | "sent";
  }[]
} | number> {
  try {
    const response = await api.get(`discussion/list/travTrocId/${trav_troc_id}`);

    if (response.status === 200) {

      return response.data;
    }
    else if (response.status === 204) {
      return response.status;
    }
    else {
      throw new Error(`Statut de réponse inconnu : ${response.status}`);
    }

  }
  catch (error) {
    throw error;
  }
}